import { useEffect, useState } from 'react'

import ActivityWrapper from '~/bootcamp/Activities/components/ActivityWrapper'

import NumbersActivityWrapper from '~/bootcamp/Activities/SanityActivities/NumberLine/NumbersActivityWrapper'

import { NumberLineActivityData, NumberLineProps } from './NumberLine.type'
import { generateNumberLineActivityData } from './NumberLine.util'
import NumberLineSlider from './NumberLineSlider'

const emptyQuestion = {
  questionExpression: '',
  setTicksManually: false,
  leftMostValue: 0,
  rightMostValue: 0,
  numberOfTicks: 0,
  startTick: 0,
  answerValue: 0,
  showValueOfEveryNthTick: 0,
  ticks: [],
  questionId: '',
  _key: '',
}

function NumberLine({
  answerState,
  onNextQuestionClick,
  onAnswerStateChange,
  actionButtonsFC: SubmitButton,
  questions,
}: NumberLineProps): React.ReactElement {
  const [activityData, setActivityData] = useState<NumberLineActivityData>({
    question: emptyQuestion,
    questionIndex: 0,
  })
  const [questionHistory, setQuestionHistory] = useState<number[]>([])
  const [userAnswer, setUserAnswer] = useState<number>(0)
  const [answerIndex, setAnswerIndex] = useState<number>(0)
  const { question } = activityData

  useEffect(() => {
    setActivityData(generateNumberLineActivityData(questions, questionHistory))
    if (!question.setTicksManually) {
      const answerTickIndex = Math.round(
        (question.answerValue - question.leftMostValue) /
          ((question.rightMostValue - question.leftMostValue) / (question.numberOfTicks - 1)),
      )
      const startTickIndex = Math.round(
        (question.startTick - question.leftMostValue) /
          ((question.rightMostValue - question.leftMostValue) / (question.numberOfTicks - 1)),
      )
      setAnswerIndex(answerTickIndex)
      setUserAnswer(startTickIndex)
    } else {
      const answerTickIndex = question.ticks.findIndex((tick) => tick.isAnswerTick)
      const startTickIndex = question.ticks.findIndex((tick) => tick.isDefaultTick)
      setAnswerIndex(answerTickIndex)
      setUserAnswer(startTickIndex)
    }
  }, [
    question.answerValue,
    questionHistory,
    questions,
    question.setTicksManually,
    question.leftMostValue,
    question.rightMostValue,
    question.numberOfTicks,
    question.ticks,
    question.startTick,
  ])

  const resetAnswer = (): void => {
    setUserAnswer(0)
  }

  const handleOnCheckAnswerClick = (): void => {
    const isCorrect = userAnswer === answerIndex
    onAnswerStateChange(isCorrect)
  }

  const handleOnNextQuestionClick = (): void => {
    setQuestionHistory((prevState) => {
      return [activityData.questionIndex, ...prevState].slice(0, questions.length - 1)
    })
    onAnswerStateChange(null)
    onNextQuestionClick()
  }

  return (
    <ActivityWrapper>
      <NumbersActivityWrapper className="my-0 w-full">
        <div className="flex flex-col text-3xl after:justify-center items-center font-semibold mb-10 text-black">
          {activityData.question.questionExpression} {/* Display the question expression */}
        </div>
        <NumberLineSlider
          activityData={activityData}
          danger={answerState === false}
          setTicksManually={activityData.question.setTicksManually}
          setValue={setUserAnswer}
          value={userAnswer}
        />
      </NumbersActivityWrapper>
      {SubmitButton && (
        <SubmitButton
          clearFormAction={() => resetAnswer()}
          correctAnswer={answerState ?? false}
          formValid
          goToNextQuestionAction={handleOnNextQuestionClick}
          submitAnswerAction={handleOnCheckAnswerClick}
        />
      )}
    </ActivityWrapper>
  )
}

export default NumberLine
